import { createContext } from 'react';

export interface IQualificationsOpenStepsContext {
  showStepOne: boolean;
  showStepTwo: boolean;
  setSteps: (stepOne?: boolean, stepTwo?: boolean) => void;
}

export const QualificationsOpenStepsContext = createContext<IQualificationsOpenStepsContext>({
  showStepOne: true,
  showStepTwo: false,
  setSteps: () => {},
});
